import type {Falsy, Nullish} from './utility-types';

export const isNullish = (val: unknown): val is Nullish => val == null;

export const isDefined = <T = unknown>(item: null | T | undefined): item is T =>
  item != null;

/**
 * Returns true if the value is falsy
 * @public
 */
export const isFalsy = (val: unknown): val is Falsy => !val;
